// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/fonts/Faculty_Glyphic/FacultyGlyphic-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../public/fonts/Lora/Lora-Italic-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../public/fonts/Merriweather/Merriweather-Italic-VariableFont_opsz,wdth,wght.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../public/fonts/Playfair_Display/PlayfairDisplay-Italic-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../public/fonts/Lora/static/Lora-SemiBoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../public/images/background.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../public/images/backforsmalscreen.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Faculty_Glyphic';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'Lora_Italic';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'Merriweather_Italic';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'Playfair_Display_Italic';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype');
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'Lora_SemiBoldItalic';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('truetype');
  font-style: normal;
  font-display: swap;
}
:root {
  --parchment: #f4e8c1;
  --parchment-soft: #fbf6e4;
  --royal-blue: #2446c7;
  --royal-blue-dark: #1b3595;
  --text: #1f1f1f;
  --grey: #8a8f98;
  --dark-grey: #5a5a5a;
}

* {
  box-sizing: border-box;
}

body {
  margin: 0;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  color: var(--text);
  background: linear-gradient(180deg, var(--parchment-soft) 0%, var(--parchment) 100%);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  
  /* Mobile: scale image to fill the viewport (may crop edges slightly) */
  background-size: cover;
  background-color: var(--parchment-soft);
  background-position: center;
  background-repeat: no-repeat;
  /* scroll avoids iOS bugs with fixed backgrounds; desktop can override */
  background-attachment: scroll;
  min-height: 10dvh;
  min-height: 10vh;
}
.site-header{
  border-bottom-color: var(--royal-blue-dark);
  border-bottom-width: 10px;
  border-bottom-style: solid;
  border-radius: 12px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  border-top-color: var(--royal-blue-dark);
}
.site-footer{
  border-bottom-color: var(--royal-blue-dark);
  border-bottom-width: 10px;
  border-bottom-style: solid;
  border-radius: 12px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  border-top-color: var(--royal-blue-dark);
}
.site-footer p{
  font-size: 1.5rem;
  font-family: 'Merriweather_Italic', serif;
}
.site-sidebar-hours-value{
  text-align: right;
  font-size: 0.78rem;
}
.testimonials-container {
  margin-top: 1rem;
  font-size: 1.5rem;
  padding-top: 1.5rem;
  text-align: center;
  font-family: 'Merriweather_Italic', serif;
  line-height: 1.55;
  /* Reserve height for the longest quotes so shorter ones don't collapse the layout */
  min-height: max(12rem, 9lh);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 0.75rem;
  color: var(--text);
  padding-bottom: 2.78rem;
  padding-left: 2.65rem;
  padding-right: 2.65rem;

}
.testimonials-container h2 {
  margin: 0;
  width: 100%;
  color: var(--royal-blue-dark);
  font-family: 'Merriweather_Italic', serif;
  font-weight: bold;
  text-align: center;
  padding-bottom: .7rem;
}

.testimonials-container > span {
  max-width: 100%;
  min-width: 0;
}
#root {
  min-height: 100vh;
}

.page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 0.75rem 1rem 1rem;
}

.site-header {
  background: var(--royal-blue);
  color: #fff;
  padding: 1rem;
  text-align: left;
  border-radius: 12px;
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.14);
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}

.site-header-text {
  min-width: 0;
}

.cta-button {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: #fff;
  color: var(--royal-blue-dark);
  font-weight: bold;
  font-family: 'Merriweather_Italic', serif;
  font-size: clamp(1rem, 2.5vw, 1.2rem);
  padding: 0.75rem 1.4rem;
  border-radius: 999px;
  text-decoration: none;
  white-space: nowrap;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.2);
  transition: transform 0.15s ease, background 0.15s ease, color 0.15s ease;
}

.cta-button-icon {
  flex-shrink: 0;
}

.cta-button:hover,
.cta-button:focus-visible {
  background: var(--royal-blue-dark);
  color: #fff;
  transform: translateY(-2px);
}

.site-title {
  margin: 0;
  font-size: 1.5rem;
  line-height: 1.2;
  font-family: 'Faculty_Glyphic' !important;
  align-items: left;
  padding-left: 0.75rem;
}

.site-subtitle {
  margin: 0.4rem 0 0;
  font-size: 0.95rem;
  opacity: 0.95;
  font-family: 'Merriweather_Italic', serif;
  text-align: left;
  padding-left: 0.75rem;
}

.content-welcome-container {
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;
  
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 1rem;
  min-height: 100%;
}

.content-cards {
  flex: 1;
  min-width: 0;
  width: 100%;
  background-color: rgba(251, 246, 228, 0.92);
  border: 2px solid rgba(36, 70, 199, 0.2);
  border-radius: 12px;
  padding-bottom: 0%;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
  border-bottom-width: 40px;
  border-bottom-color: rgb(196, 192, 177);
}
.content-cards p {
  padding-bottom: .2rem;
}
.content-cards-welcome {
  padding-bottom: 1rem;
  text-align: center;
  padding-top: 0.5rem;
}
.content-cards-welcome h2 {
  margin-top: 0;
  color: var(--royal-blue-dark);
  font-family: 'Merriweather_Italic', serif;
  font-weight: bold;
  padding-top: 0.8rem;
}
.content-cards-welcome p {
  padding-bottom: 0;
  line-height: 1.55;
  font-size: 1.5rem;
  font-family: 'Lora_Italic', serif;
  padding-left: 2.65rem;
  padding-right: 2.65rem;
}

.content-cards h2 {
  margin-top: 0;
  color: var(--royal-blue-dark);
}
.page p{
  padding-bottom: .2rem;
}

.photo-gallery-widget {
  margin-top: 1rem;
  padding: 0 2.65rem 1rem;
  text-align: center;
  border: 10px solid var(grey);
  border-radius: 12px;
  border-bottom-width: 40px;
  border-top-width: 30px;
  
  
}

.photo-gallery-widget h2 {
  margin-top: 0;
  color: var(--royal-blue-dark);
  font-family: 'Merriweather_Italic', serif;
  font-weight: bold;
}

.photo-gallery-slideshow {
  position: relative;
  max-width: 900px;
  margin: 0 auto;
}

.photo-gallery-stage {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.06);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
  border: 4dvi solid var(--grey);
  border-radius: 12px;
  border-bottom-width: 40px;
  border-bottom-color: var(--dark-grey);
  border-top-width: 40px;
  border-top-color: var(--dark-grey);
  border-style: ridge;
}

.photo-gallery-slide {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: zoom-in;
  opacity: 0;
  transition: opacity 0.6s ease;
  pointer-events: none;
}

.photo-gallery-slide.is-active {
  opacity: 1;
  pointer-events: auto;
}

.photo-gallery-slide img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.photo-gallery-slide-nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 2.75rem;
  height: 2.75rem;
  border: 0;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.45);
  color: #fff;
  font-size: 1.75rem;
  line-height: 1;
  cursor: pointer;
  z-index: 2;
  transition: background 0.2s ease;
}

.photo-gallery-slide-prev {
  left: 0.75rem;
}

.photo-gallery-slide-next {
  right: 0.75rem;
}

.photo-gallery-slide-nav:hover,
.photo-gallery-slide-nav:focus-visible {
  background: rgba(0, 0, 0, 0.7);
}

.photo-gallery-dots {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  margin: 0;
  z-index: 3;
}

.photo-gallery-dot {
  width: 0.7rem;
  height: 0.7rem;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.6);
  cursor: pointer;
  transition: background 0.2s ease, transform 0.2s ease;
}

.photo-gallery-dot:hover,
.photo-gallery-dot:focus-visible {
  background: rgba(255, 255, 255, 0.85);
}

.photo-gallery-dot.is-active {
  background: #fff;
  transform: scale(1.2);
}

.photo-gallery-empty {
  padding: 2rem;
  border: 2px dashed rgba(36, 70, 199, 0.25);
  border-radius: 12px;
  background: rgba(255, 254, 249, 0.75);
  color: var(--royal-blue-dark);
  font-family: 'Lora_Italic', serif;
}

.photo-gallery-lightbox {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background: rgba(0, 0, 0, 0.85);
}

.photo-gallery-lightbox-image {
  max-width: 92vw;
  max-height: 88vh;
  border-radius: 8px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.6);
}

.photo-gallery-lightbox-close,
.photo-gallery-lightbox-nav {
  position: absolute;
  width: 3rem;
  height: 3rem;
  border: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.15);
  color: #fff;
  font-size: 2rem;
  line-height: 1;
  cursor: pointer;
}

.photo-gallery-lightbox-close {
  top: 1rem;
  right: 1rem;
}

.photo-gallery-lightbox-prev {
  left: 1rem;
  top: 50%;
  transform: translateY(-50%);
}

.photo-gallery-lightbox-next {
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
}

.photo-gallery-lightbox-close:hover,
.photo-gallery-lightbox-nav:hover,
.photo-gallery-lightbox-close:focus-visible,
.photo-gallery-lightbox-nav:focus-visible {
  background: rgba(255, 255, 255, 0.3);
}


.site-sidebar {
  width: 100%;
  background: var(--royal-blue);
  color: #fff;
  border: 10px solid rgba(255, 255, 255, 0.25);
  border-radius: 30px;
  border-top-width: 30px;
  border-bottom-width: 40px;
  padding: 1rem 1.1rem;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
  line-height: 1.45;
  font-family: 'Merriweather_Italic', serif;
  /* Fluid: bigger on small screens, eases down on larger screens */
  font-size: clamp(0.95rem, 2.6rem - 2.4vw, 1.3rem);
}

.site-sidebar-title {
  margin: 0 0 0.75rem;
  font-size: 1.15rem;
  font-family: 'Playfair_Display_Italic ', serif;
  color: #fff;
}

.site-sidebar-block + .site-sidebar-block {
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid rgba(255, 255, 255, 0.25);
}

.site-sidebar-heading {
  margin: 0 0 0.5rem;
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #fff;
  opacity: 0.85;
}

.site-sidebar-hours {
  margin: 0;
  padding: 0;
  list-style: none;
  font-family: 'Merriweather_Italic', serif;
  font-size: clamp(0.8rem, 1.9rem - 1.6vw, 1.05rem);
}

.site-sidebar-hours li {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: baseline;
  gap: 0.5rem;
  padding: 0.2rem 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);
}

.site-sidebar-hours li:last-child {
  border-bottom: none;
}

.site-sidebar-hours-label {
  color: #fff;
  opacity: 0.9;
  white-space: nowrap;
}

.site-sidebar-hours-value {
  font-weight: 500;
  text-align: right;
  white-space: nowrap;
  font-size: clamp(0.72rem, 1.6rem - 1.4vw, 0.95rem);
}

.site-sidebar-line {
  margin: 0 0 0.4rem;
}

.site-sidebar-line:last-of-type {
  margin-bottom: 0;
}

.site-sidebar-line a,
.site-sidebar-address a {
  color: #fff;
  text-decoration: underline;
}

.site-sidebar-line a:hover,
.site-sidebar-address a:hover {
  text-decoration: underline;
}

.site-sidebar-address {
  margin: 0.6rem 0 0;
  line-height: 1.5;
}

.site-sidebar-map-heading {
  margin-top: 1rem;
}

.site-sidebar-map {
  margin-top: 0.5rem;
  border-radius: 30px;
  border-color: grey;
  overflow: hidden;
  border: 15px solid rgba(255, 255, 255, 0.3);
  background: rgba(0, 0, 0, 0.04);
  aspect-ratio: 4 / 3;
  min-height: 160px;
}

.site-sidebar-map-frame {
  display: block;
  width: 100%;
  height: 100%;
  min-height: 160px;
  border: 0;
}

.content-card h2 {
  margin-top: 0;
  color: var(--royal-blue-dark);
}

.content-card p {
  margin-bottom: 0;
  line-height: 1.55;
}

.site-footer {
  background: var(--royal-blue);
  color: #fff;
  text-align: center;
  padding: 0.8rem 1rem;
  font-size: 0.9rem;
  border-radius: 12px;
  box-shadow: 0 4px 18px rgba(2, 3, 116, 0.14);
}

.site-footer a {
  color: #fff;
  text-decoration: none;
}

.site-footer a:hover {
  text-decoration: underline;
}
.chiropractic-info-widget {
  margin-top: 1rem;
  font-size: 1.2rem;
  text-align: center;
  padding-top: 0.1rem;

}
.chiropractic-info-widget h2 {
  margin-top: 0;
  color: var(--royal-blue-dark);
  font-family: 'Merriweather_Italic', serif;
  font-weight: bold;
  
}
.chiropractic-info-widget p {
  margin-bottom: 0;
  line-height: 1.55;
  font-family: 'Lora_Italic', serif;
  font-size: 1.5rem;
  padding-left: 2.65rem;
  padding-right: 2.65rem;
  padding-bottom: 30px;
}
.chiropractic-info-infobox {
  border: 9px solid var(--royal-blue-dark);
  border-bottom-width: 40px;
  padding-right: 0.98rem;
  padding-left: 0.98rem;
  border-radius: 12px;
  background-color: var(--royal-blue);
  color: #fff;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
  padding-top: 30px;
}
.chiropractic-info-infobox p {
  margin-bottom: 0;
  line-height: 1.55;
  font-family: 'Faculty_Glyphic', serif;
  font-size: 1.5rem;
  padding-left: 2.65rem;
  padding-right: 2.65rem;
  color: #fff;
  
}

.nsa-term {
  position: relative;
  color: var(--royal-blue-dark);
  font-weight: bold;
  text-decoration: underline dotted;
  text-underline-offset: 3px;
  cursor: help;
}

.nsa-popover {
  position: absolute;
  left: 50%;
  top: calc(100% + 0.5rem);
  transform: translateX(-50%) translateY(6px);
  width: min(440px, 90vw);
  max-height: 60vh;
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  padding: 0.75rem 1rem;
  background: #fffef9;
  color: var(--text);
  border: 2px solid var(--royal-blue-dark);
  border-radius: 12px;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.25);
  text-align: left;
  font-size: 1rem;
  z-index: 50;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.nsa-term.is-open .nsa-popover {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
  transform: translateX(-50%) translateY(0);
}

.nsa-popover .nsa-widget h2 {
  margin: 0.25rem 0 0.4rem;
  font-size: clamp(1.2rem, 6vw, 2.5rem);
  color: var(--royal-blue-dark);
  font-family: 'Merriweather_Italic', serif;
}

.nsa-popover .nsa-widget p {
  margin: 0 0 0.6rem;
  padding: 0;
  font-size: clamp(0.95rem, 3.2vw, 1.55rem);
  line-height: 1.5;
  font-family: 'Merriweather_Italic', serif;
}

.nsa-popover .nsa-widget ul {
  margin: 0 0 0.6rem;
  padding-left: 1.1rem;
  text-align: left;
}

.nsa-popover .nsa-widget li {
  margin-bottom: 0.35rem;
  font-size: clamp(0.95rem, 3.2vw, 1.55rem);
  line-height: 1.45;
}

.nsa-benefit-term {
  color: var(--royal-blue);
  font-weight: bold;
}

.nsa-popover-close {
  position: sticky;
  top: 0;
  display: block;
  margin-left: auto;
  margin-right: 0;
  width: 2rem;
  height: 2rem;
  border: 0;
  border-radius: 50%;
  background: var(--royal-blue);
  color: #fff;
  font-size: 1.4rem;
  line-height: 1;
  cursor: pointer;
  z-index: 2;
}

.nsa-popover-close:hover,
.nsa-popover-close:focus-visible {
  background: var(--royal-blue-dark);
}

/* On phones, center the popover in the viewport so it never runs off-screen */
@media (max-width: 600px) {
  .nsa-popover {
    position: fixed;
    left: 50%;
    top: 50%;
    width: 92vw;
    max-width: 92vw;
    max-height: 80vh;
    transform: translate(-50%, -48%);
  }

  .nsa-term.is-open .nsa-popover {
    transform: translate(-50%, -50%);
  }
}
.about-me-widget {
  margin-top: 1rem;
  font-size: 1.2rem;
  text-align: center;
  padding-top: 5rem;

}
.about-me-widget img {
  display:flex;
  width: 100%;
  max-width: 550px;
  height: 100%;
  object-fit: cover;
  border-radius: 12px;
  margin: 0 auto 1.5rem;
  border: 30px solid var(--royal-blue-dark);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
  
  border-bottom-width: 30px;
  border-top-width: 30px;
  border-style: ridge;
}
.about-me-widget h2 {
  margin-top: 0;
  color: var(--royal-blue-dark);
  font-family: 'Merriweather_Italic', serif;
  font-weight: bold;
  font-size: 1.95rem;
}
.about-me-widget p {
  margin-bottom: 0;
  line-height: 1.55;
  font-family: 'Lora_SemiBoldItalic', serif;
  font-size: 1.5rem;
  padding-left: 2.65rem;
  padding-right: 2.65rem;
  
}
.second-description-widget {
  margin-top: 1rem;
  font-size: 1.2rem;
  text-align: center;
  padding-top: 5rem;
  padding-bottom: 2rem;
}
.second-description-widget p {
  margin-bottom: 0;
  line-height: 1.55;
  font-family: 'Lora_Italic', serif;
  font-size: 1.5rem;
  padding-left: 2.65rem;
  padding-right: 2.65rem;
  padding-bottom: 50px;
  border: 2px solid var(--royal-blue-dark);
  border-radius: 12px;
  border-bottom-width: 40px;
  background-color: var(--royal-blue);
  color: #fff;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
  padding-top: 30px;
}
@media (min-width: 900px) {
  body {
    background-size: 40vh auto;
  }

  .content-welcome-container {
    flex-direction: row;
    align-items: flex-start;
    gap: 1.25rem;
  }

  .site-sidebar {
    width: 280px;
    flex-shrink: 0;
    order: 1;
  }

  .content-card-testimonials {
    order: 2;
  }
}


@media (min-width: 768px) {
  .page {
    padding: 1rem 1.25rem 1.25rem;
    gap: 1rem;
  }

  body {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    background-attachment: fixed;
  }

  .site-header {
    padding: 1.4rem;
  }

  .site-title {
    font-size: 2rem;
    padding-left: 1rem;
  }

  .site-subtitle {
    font-size: 1.05rem;
    padding-left: 1rem;
  }

  .content-wrapper {
    padding: 2rem;
  }

  .content-card {
    padding: 1.5rem 2rem;
  }

  .content-card-testimonials {
    padding: 1.5rem 2rem;
  }

  .site-sidebar {
    padding: 1.25rem 1.35rem;
    font-family: 'Merriweather_Italic', serif;
  }
}
@media screen and (min-width: 320px) and (max-width: 800px) {
  body {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    background-attachment: fixed;
  }
  .photo-gallery-stage {
    aspect-ratio: 4 / 3;
  }
}

`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,+DAAyF;EACzF,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,+DAAqF;EACrF,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,kCAAkC;EAClC,+DAA+G;EAC/G,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,sCAAsC;EACtC,+DAA4G;EAC5G,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,kCAAkC;EAClC,+DAAkF;EAClF,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,qBAAqB;EACrB,0BAA0B;EAC1B,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,4DAA4D;EAC5D,kBAAkB;EAClB,oFAAoF;EACpF,yDAAwD;;EAExD,uEAAuE;EACvE,sBAAsB;EACtB,uCAAuC;EACvC,2BAA2B;EAC3B,4BAA4B;EAC5B,wEAAwE;EACxE,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,2CAA2C;EAC3C,yBAAyB;EACzB,0BAA0B;EAC1B,mBAAmB;EACnB,4BAA4B;EAC5B,6BAA6B;EAC7B,4BAA4B;EAC5B,6BAA6B;EAC7B,wCAAwC;AAC1C;AACA;EACE,2CAA2C;EAC3C,yBAAyB;EACzB,0BAA0B;EAC1B,mBAAmB;EACnB,4BAA4B;EAC5B,6BAA6B;EAC7B,4BAA4B;EAC5B,6BAA6B;EAC7B,wCAAwC;AAC1C;AACA;EACE,iBAAiB;EACjB,yCAAyC;AAC3C;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;EACzC,iBAAiB;EACjB,oFAAoF;EACpF,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,qBAAqB;EACrB,sBAAsB;;AAExB;AACA;EACE,SAAS;EACT,WAAW;EACX,6BAA6B;EAC7B,yCAAyC;EACzC,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,6BAA6B;EAC7B,iBAAiB;EACjB,yCAAyC;EACzC,qCAAqC;EACrC,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;EACnB,yCAAyC;EACzC,yEAAyE;AAC3E;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,kCAAkC;EAClC,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,yCAAyC;EACzC,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,yCAAyC;EACzC,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;;EAEd,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,WAAW;EACX,2CAA2C;EAC3C,wCAAwC;EACxC,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;EAC1C,yBAAyB;EACzB,uCAAuC;AACzC;AACA;EACE,qBAAqB;AACvB;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,6BAA6B;EAC7B,yCAAyC;EACzC,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iCAAiC;EACjC,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,4BAA4B;EAC5B,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;;;AAGxB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,yCAAyC;EACzC,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,+BAA+B;EAC/B,0CAA0C;EAC1C,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,qCAAqC;EACrC,sBAAsB;EACtB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,UAAU;EACV,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,+BAA+B;EAC/B,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,cAAc;EACd,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,oCAAoC;EACpC,eAAe;EACf,qDAAqD;AACvD;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,qCAAqC;EACrC,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,qCAAqC;EACrC,WAAW;EACX,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;;;;EAIE,oCAAoC;AACtC;;;AAGA;EACE,WAAW;EACX,6BAA6B;EAC7B,WAAW;EACX,4CAA4C;EAC5C,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB;EACpB,0CAA0C;EAC1C,iBAAiB;EACjB,yCAAyC;EACzC,iEAAiE;EACjE,iDAAiD;AACnD;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,8CAA8C;EAC9C,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,yCAAyC;EACzC,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,8BAA8B;EAC9B,qBAAqB;EACrB,WAAW;EACX,iBAAiB;EACjB,kDAAkD;AACpD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kDAAkD;AACpD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,0BAA0B;AAC5B;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;EAC3C,+BAA+B;EAC/B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;;AAErB;AACA;EACE,aAAa;EACb,6BAA6B;EAC7B,yCAAyC;EACzC,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iCAAiC;EACjC,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,oBAAoB;AACtB;AACA;EACE,wCAAwC;EACxC,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;EACnB,mCAAmC;EACnC,WAAW;EACX,0CAA0C;EAC1C,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,qCAAqC;EACrC,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,WAAW;;AAEb;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,iBAAiB;EACjB,iCAAiC;EACjC,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,wBAAwB;EACxB,2CAA2C;EAC3C,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;EAC5B,iCAAiC;EACjC,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,wCAAwC;EACxC,mBAAmB;EACnB,2CAA2C;EAC3C,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,oBAAoB;EACpB,kDAAkD;AACpD;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,wBAAwB;EACxB,qCAAqC;EACrC,6BAA6B;EAC7B,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,yCAAyC;EACzC,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,yCAAyC;EACzC,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,UAAU;AACZ;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA,8EAA8E;AAC9E;EACE;IACE,eAAe;IACf,SAAS;IACT,QAAQ;IACR,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,gCAAgC;EAClC;;EAEA;IACE,gCAAgC;EAClC;AACF;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;;AAEnB;AACA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,yCAAyC;EACzC,0CAA0C;;EAE1C,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,6BAA6B;EAC7B,yCAAyC;EACzC,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;EACzC,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;;AAExB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iCAAiC;EACjC,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,oBAAoB;EACpB,wCAAwC;EACxC,mBAAmB;EACnB,yBAAyB;EACzB,mCAAmC;EACnC,WAAW;EACX,0CAA0C;EAC1C,iBAAiB;AACnB;AACA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,cAAc;IACd,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;AACF;;;AAGA;EACE;IACE,6BAA6B;IAC7B,SAAS;EACX;;EAEA;IACE,yDAA+D;IAC/D,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;IAC5B,4BAA4B;EAC9B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,wBAAwB;IACxB,yCAAyC;EAC3C;AACF;AACA;EACE;IACE,yDAA+D;IAC/D,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;IAC5B,4BAA4B;EAC9B;EACA;IACE,mBAAmB;EACrB;AACF","sourcesContent":["@font-face {\n  font-family: 'Faculty_Glyphic';\n  src: url('../public/fonts/Faculty_Glyphic/FacultyGlyphic-Regular.ttf') format('truetype');\n  font-style: normal;\n  font-display: swap;\n}\n@font-face {\n  font-family: 'Lora_Italic';\n  src: url('../public/fonts/Lora/Lora-Italic-VariableFont_wght.ttf') format('truetype');\n  font-style: normal;\n  font-display: swap;\n}\n@font-face {\n  font-family: 'Merriweather_Italic';\n  src: url('../public/fonts/Merriweather/Merriweather-Italic-VariableFont_opsz,wdth,wght.ttf') format('truetype');\n  font-style: normal;\n  font-display: swap;\n}\n@font-face {\n  font-family: 'Playfair_Display_Italic';\n  src: url('../public/fonts/Playfair_Display/PlayfairDisplay-Italic-VariableFont_wght.ttf') format('truetype');\n  font-style: normal;\n  font-display: swap;\n}\n@font-face {\n  font-family: 'Lora_SemiBoldItalic';\n  src: url('../public/fonts/Lora/static/Lora-SemiBoldItalic.ttf') format('truetype');\n  font-style: normal;\n  font-display: swap;\n}\n:root {\n  --parchment: #f4e8c1;\n  --parchment-soft: #fbf6e4;\n  --royal-blue: #2446c7;\n  --royal-blue-dark: #1b3595;\n  --text: #1f1f1f;\n  --grey: #8a8f98;\n  --dark-grey: #5a5a5a;\n}\n\n* {\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 0;\n  font-family: \"Segoe UI\", Tahoma, Geneva, Verdana, sans-serif;\n  color: var(--text);\n  background: linear-gradient(180deg, var(--parchment-soft) 0%, var(--parchment) 100%);\n  background-image: url('../public/images/background.jpg');\n  \n  /* Mobile: scale image to fill the viewport (may crop edges slightly) */\n  background-size: cover;\n  background-color: var(--parchment-soft);\n  background-position: center;\n  background-repeat: no-repeat;\n  /* scroll avoids iOS bugs with fixed backgrounds; desktop can override */\n  background-attachment: scroll;\n  min-height: 10dvh;\n  min-height: 10vh;\n}\n.site-header{\n  border-bottom-color: var(--royal-blue-dark);\n  border-bottom-width: 10px;\n  border-bottom-style: solid;\n  border-radius: 12px;\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n  border-top-left-radius: 12px;\n  border-top-right-radius: 12px;\n  border-top-color: var(--royal-blue-dark);\n}\n.site-footer{\n  border-bottom-color: var(--royal-blue-dark);\n  border-bottom-width: 10px;\n  border-bottom-style: solid;\n  border-radius: 12px;\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n  border-top-left-radius: 12px;\n  border-top-right-radius: 12px;\n  border-top-color: var(--royal-blue-dark);\n}\n.site-footer p{\n  font-size: 1.5rem;\n  font-family: 'Merriweather_Italic', serif;\n}\n.site-sidebar-hours-value{\n  text-align: right;\n  font-size: 0.78rem;\n}\n.testimonials-container {\n  margin-top: 1rem;\n  font-size: 1.5rem;\n  padding-top: 1.5rem;\n  text-align: center;\n  font-family: 'Merriweather_Italic', serif;\n  line-height: 1.55;\n  /* Reserve height for the longest quotes so shorter ones don't collapse the layout */\n  min-height: max(12rem, 9lh);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 0.75rem;\n  color: var(--text);\n  padding-bottom: 2.78rem;\n  padding-left: 2.65rem;\n  padding-right: 2.65rem;\n\n}\n.testimonials-container h2 {\n  margin: 0;\n  width: 100%;\n  color: var(--royal-blue-dark);\n  font-family: 'Merriweather_Italic', serif;\n  font-weight: bold;\n  text-align: center;\n  padding-bottom: .7rem;\n}\n\n.testimonials-container > span {\n  max-width: 100%;\n  min-width: 0;\n}\n#root {\n  min-height: 100vh;\n}\n\n.page {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  padding: 0.75rem 1rem 1rem;\n}\n\n.site-header {\n  background: var(--royal-blue);\n  color: #fff;\n  padding: 1rem;\n  text-align: left;\n  border-radius: 12px;\n  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.14);\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n}\n\n.site-header-text {\n  min-width: 0;\n}\n\n.cta-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  background: #fff;\n  color: var(--royal-blue-dark);\n  font-weight: bold;\n  font-family: 'Merriweather_Italic', serif;\n  font-size: clamp(1rem, 2.5vw, 1.2rem);\n  padding: 0.75rem 1.4rem;\n  border-radius: 999px;\n  text-decoration: none;\n  white-space: nowrap;\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.2);\n  transition: transform 0.15s ease, background 0.15s ease, color 0.15s ease;\n}\n\n.cta-button-icon {\n  flex-shrink: 0;\n}\n\n.cta-button:hover,\n.cta-button:focus-visible {\n  background: var(--royal-blue-dark);\n  color: #fff;\n  transform: translateY(-2px);\n}\n\n.site-title {\n  margin: 0;\n  font-size: 1.5rem;\n  line-height: 1.2;\n  font-family: 'Faculty_Glyphic' !important;\n  align-items: left;\n  padding-left: 0.75rem;\n}\n\n.site-subtitle {\n  margin: 0.4rem 0 0;\n  font-size: 0.95rem;\n  opacity: 0.95;\n  font-family: 'Merriweather_Italic', serif;\n  text-align: left;\n  padding-left: 0.75rem;\n}\n\n.content-welcome-container {\n  width: 100%;\n  max-width: 1100px;\n  margin: 0 auto;\n  \n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 1rem;\n  min-height: 100%;\n}\n\n.content-cards {\n  flex: 1;\n  min-width: 0;\n  width: 100%;\n  background-color: rgba(251, 246, 228, 0.92);\n  border: 2px solid rgba(36, 70, 199, 0.2);\n  border-radius: 12px;\n  padding-bottom: 0%;\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);\n  border-bottom-width: 40px;\n  border-bottom-color: rgb(196, 192, 177);\n}\n.content-cards p {\n  padding-bottom: .2rem;\n}\n.content-cards-welcome {\n  padding-bottom: 1rem;\n  text-align: center;\n  padding-top: 0.5rem;\n}\n.content-cards-welcome h2 {\n  margin-top: 0;\n  color: var(--royal-blue-dark);\n  font-family: 'Merriweather_Italic', serif;\n  font-weight: bold;\n  padding-top: 0.8rem;\n}\n.content-cards-welcome p {\n  padding-bottom: 0;\n  line-height: 1.55;\n  font-size: 1.5rem;\n  font-family: 'Lora_Italic', serif;\n  padding-left: 2.65rem;\n  padding-right: 2.65rem;\n}\n\n.content-cards h2 {\n  margin-top: 0;\n  color: var(--royal-blue-dark);\n}\n.page p{\n  padding-bottom: .2rem;\n}\n\n.photo-gallery-widget {\n  margin-top: 1rem;\n  padding: 0 2.65rem 1rem;\n  text-align: center;\n  border: 10px solid var(grey);\n  border-radius: 12px;\n  border-bottom-width: 40px;\n  border-top-width: 30px;\n  \n  \n}\n\n.photo-gallery-widget h2 {\n  margin-top: 0;\n  color: var(--royal-blue-dark);\n  font-family: 'Merriweather_Italic', serif;\n  font-weight: bold;\n}\n\n.photo-gallery-slideshow {\n  position: relative;\n  max-width: 900px;\n  margin: 0 auto;\n}\n\n.photo-gallery-stage {\n  position: relative;\n  width: 100%;\n  aspect-ratio: 16 / 9;\n  overflow: hidden;\n  background: rgba(0, 0, 0, 0.06);\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);\n  border: 4dvi solid var(--grey);\n  border-radius: 12px;\n  border-bottom-width: 40px;\n  border-bottom-color: var(--dark-grey);\n  border-top-width: 40px;\n  border-top-color: var(--dark-grey);\n  border-style: ridge;\n}\n\n.photo-gallery-slide {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  cursor: zoom-in;\n  opacity: 0;\n  transition: opacity 0.6s ease;\n  pointer-events: none;\n}\n\n.photo-gallery-slide.is-active {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n.photo-gallery-slide img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.photo-gallery-slide-nav {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 2.75rem;\n  height: 2.75rem;\n  border: 0;\n  border-radius: 50%;\n  background: rgba(0, 0, 0, 0.45);\n  color: #fff;\n  font-size: 1.75rem;\n  line-height: 1;\n  cursor: pointer;\n  z-index: 2;\n  transition: background 0.2s ease;\n}\n\n.photo-gallery-slide-prev {\n  left: 0.75rem;\n}\n\n.photo-gallery-slide-next {\n  right: 0.75rem;\n}\n\n.photo-gallery-slide-nav:hover,\n.photo-gallery-slide-nav:focus-visible {\n  background: rgba(0, 0, 0, 0.7);\n}\n\n.photo-gallery-dots {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  margin: 0;\n  z-index: 3;\n}\n\n.photo-gallery-dot {\n  width: 0.7rem;\n  height: 0.7rem;\n  padding: 0;\n  border: 0;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.6);\n  cursor: pointer;\n  transition: background 0.2s ease, transform 0.2s ease;\n}\n\n.photo-gallery-dot:hover,\n.photo-gallery-dot:focus-visible {\n  background: rgba(255, 255, 255, 0.85);\n}\n\n.photo-gallery-dot.is-active {\n  background: #fff;\n  transform: scale(1.2);\n}\n\n.photo-gallery-empty {\n  padding: 2rem;\n  border: 2px dashed rgba(36, 70, 199, 0.25);\n  border-radius: 12px;\n  background: rgba(255, 254, 249, 0.75);\n  color: var(--royal-blue-dark);\n  font-family: 'Lora_Italic', serif;\n}\n\n.photo-gallery-lightbox {\n  position: fixed;\n  inset: 0;\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n  background: rgba(0, 0, 0, 0.85);\n}\n\n.photo-gallery-lightbox-image {\n  max-width: 92vw;\n  max-height: 88vh;\n  border-radius: 8px;\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.6);\n}\n\n.photo-gallery-lightbox-close,\n.photo-gallery-lightbox-nav {\n  position: absolute;\n  width: 3rem;\n  height: 3rem;\n  border: 0;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.15);\n  color: #fff;\n  font-size: 2rem;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.photo-gallery-lightbox-close {\n  top: 1rem;\n  right: 1rem;\n}\n\n.photo-gallery-lightbox-prev {\n  left: 1rem;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.photo-gallery-lightbox-next {\n  right: 1rem;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.photo-gallery-lightbox-close:hover,\n.photo-gallery-lightbox-nav:hover,\n.photo-gallery-lightbox-close:focus-visible,\n.photo-gallery-lightbox-nav:focus-visible {\n  background: rgba(255, 255, 255, 0.3);\n}\n\n\n.site-sidebar {\n  width: 100%;\n  background: var(--royal-blue);\n  color: #fff;\n  border: 10px solid rgba(255, 255, 255, 0.25);\n  border-radius: 30px;\n  border-top-width: 30px;\n  border-bottom-width: 40px;\n  padding: 1rem 1.1rem;\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);\n  line-height: 1.45;\n  font-family: 'Merriweather_Italic', serif;\n  /* Fluid: bigger on small screens, eases down on larger screens */\n  font-size: clamp(0.95rem, 2.6rem - 2.4vw, 1.3rem);\n}\n\n.site-sidebar-title {\n  margin: 0 0 0.75rem;\n  font-size: 1.15rem;\n  font-family: 'Playfair_Display_Italic ', serif;\n  color: #fff;\n}\n\n.site-sidebar-block + .site-sidebar-block {\n  margin-top: 1rem;\n  padding-top: 1rem;\n  border-top: 1px solid rgba(255, 255, 255, 0.25);\n}\n\n.site-sidebar-heading {\n  margin: 0 0 0.5rem;\n  font-size: 0.8rem;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #fff;\n  opacity: 0.85;\n}\n\n.site-sidebar-hours {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  font-family: 'Merriweather_Italic', serif;\n  font-size: clamp(0.8rem, 1.9rem - 1.6vw, 1.05rem);\n}\n\n.site-sidebar-hours li {\n  display: flex;\n  flex-wrap: nowrap;\n  justify-content: space-between;\n  align-items: baseline;\n  gap: 0.5rem;\n  padding: 0.2rem 0;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.15);\n}\n\n.site-sidebar-hours li:last-child {\n  border-bottom: none;\n}\n\n.site-sidebar-hours-label {\n  color: #fff;\n  opacity: 0.9;\n  white-space: nowrap;\n}\n\n.site-sidebar-hours-value {\n  font-weight: 500;\n  text-align: right;\n  white-space: nowrap;\n  font-size: clamp(0.72rem, 1.6rem - 1.4vw, 0.95rem);\n}\n\n.site-sidebar-line {\n  margin: 0 0 0.4rem;\n}\n\n.site-sidebar-line:last-of-type {\n  margin-bottom: 0;\n}\n\n.site-sidebar-line a,\n.site-sidebar-address a {\n  color: #fff;\n  text-decoration: underline;\n}\n\n.site-sidebar-line a:hover,\n.site-sidebar-address a:hover {\n  text-decoration: underline;\n}\n\n.site-sidebar-address {\n  margin: 0.6rem 0 0;\n  line-height: 1.5;\n}\n\n.site-sidebar-map-heading {\n  margin-top: 1rem;\n}\n\n.site-sidebar-map {\n  margin-top: 0.5rem;\n  border-radius: 30px;\n  border-color: grey;\n  overflow: hidden;\n  border: 15px solid rgba(255, 255, 255, 0.3);\n  background: rgba(0, 0, 0, 0.04);\n  aspect-ratio: 4 / 3;\n  min-height: 160px;\n}\n\n.site-sidebar-map-frame {\n  display: block;\n  width: 100%;\n  height: 100%;\n  min-height: 160px;\n  border: 0;\n}\n\n.content-card h2 {\n  margin-top: 0;\n  color: var(--royal-blue-dark);\n}\n\n.content-card p {\n  margin-bottom: 0;\n  line-height: 1.55;\n}\n\n.site-footer {\n  background: var(--royal-blue);\n  color: #fff;\n  text-align: center;\n  padding: 0.8rem 1rem;\n  font-size: 0.9rem;\n  border-radius: 12px;\n  box-shadow: 0 4px 18px rgba(2, 3, 116, 0.14);\n}\n\n.site-footer a {\n  color: #fff;\n  text-decoration: none;\n}\n\n.site-footer a:hover {\n  text-decoration: underline;\n}\n.chiropractic-info-widget {\n  margin-top: 1rem;\n  font-size: 1.2rem;\n  text-align: center;\n  padding-top: 0.1rem;\n\n}\n.chiropractic-info-widget h2 {\n  margin-top: 0;\n  color: var(--royal-blue-dark);\n  font-family: 'Merriweather_Italic', serif;\n  font-weight: bold;\n  \n}\n.chiropractic-info-widget p {\n  margin-bottom: 0;\n  line-height: 1.55;\n  font-family: 'Lora_Italic', serif;\n  font-size: 1.5rem;\n  padding-left: 2.65rem;\n  padding-right: 2.65rem;\n  padding-bottom: 30px;\n}\n.chiropractic-info-infobox {\n  border: 9px solid var(--royal-blue-dark);\n  border-bottom-width: 40px;\n  padding-right: 0.98rem;\n  padding-left: 0.98rem;\n  border-radius: 12px;\n  background-color: var(--royal-blue);\n  color: #fff;\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);\n  padding-top: 30px;\n}\n.chiropractic-info-infobox p {\n  margin-bottom: 0;\n  line-height: 1.55;\n  font-family: 'Faculty_Glyphic', serif;\n  font-size: 1.5rem;\n  padding-left: 2.65rem;\n  padding-right: 2.65rem;\n  color: #fff;\n  \n}\n\n.nsa-term {\n  position: relative;\n  color: var(--royal-blue-dark);\n  font-weight: bold;\n  text-decoration: underline dotted;\n  text-underline-offset: 3px;\n  cursor: help;\n}\n\n.nsa-popover {\n  position: absolute;\n  left: 50%;\n  top: calc(100% + 0.5rem);\n  transform: translateX(-50%) translateY(6px);\n  width: min(440px, 90vw);\n  max-height: 60vh;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  -webkit-overflow-scrolling: touch;\n  padding: 0.75rem 1rem;\n  background: #fffef9;\n  color: var(--text);\n  border: 2px solid var(--royal-blue-dark);\n  border-radius: 12px;\n  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.25);\n  text-align: left;\n  font-size: 1rem;\n  z-index: 50;\n  opacity: 0;\n  visibility: hidden;\n  pointer-events: none;\n  transition: opacity 0.2s ease, transform 0.2s ease;\n}\n\n.nsa-term.is-open .nsa-popover {\n  opacity: 1;\n  visibility: visible;\n  pointer-events: auto;\n  transform: translateX(-50%) translateY(0);\n}\n\n.nsa-popover .nsa-widget h2 {\n  margin: 0.25rem 0 0.4rem;\n  font-size: clamp(1.2rem, 6vw, 2.5rem);\n  color: var(--royal-blue-dark);\n  font-family: 'Merriweather_Italic', serif;\n}\n\n.nsa-popover .nsa-widget p {\n  margin: 0 0 0.6rem;\n  padding: 0;\n  font-size: clamp(0.95rem, 3.2vw, 1.55rem);\n  line-height: 1.5;\n  font-family: 'Merriweather_Italic', serif;\n}\n\n.nsa-popover .nsa-widget ul {\n  margin: 0 0 0.6rem;\n  padding-left: 1.1rem;\n  text-align: left;\n}\n\n.nsa-popover .nsa-widget li {\n  margin-bottom: 0.35rem;\n  font-size: clamp(0.95rem, 3.2vw, 1.55rem);\n  line-height: 1.45;\n}\n\n.nsa-benefit-term {\n  color: var(--royal-blue);\n  font-weight: bold;\n}\n\n.nsa-popover-close {\n  position: sticky;\n  top: 0;\n  display: block;\n  margin-left: auto;\n  margin-right: 0;\n  width: 2rem;\n  height: 2rem;\n  border: 0;\n  border-radius: 50%;\n  background: var(--royal-blue);\n  color: #fff;\n  font-size: 1.4rem;\n  line-height: 1;\n  cursor: pointer;\n  z-index: 2;\n}\n\n.nsa-popover-close:hover,\n.nsa-popover-close:focus-visible {\n  background: var(--royal-blue-dark);\n}\n\n/* On phones, center the popover in the viewport so it never runs off-screen */\n@media (max-width: 600px) {\n  .nsa-popover {\n    position: fixed;\n    left: 50%;\n    top: 50%;\n    width: 92vw;\n    max-width: 92vw;\n    max-height: 80vh;\n    transform: translate(-50%, -48%);\n  }\n\n  .nsa-term.is-open .nsa-popover {\n    transform: translate(-50%, -50%);\n  }\n}\n.about-me-widget {\n  margin-top: 1rem;\n  font-size: 1.2rem;\n  text-align: center;\n  padding-top: 5rem;\n\n}\n.about-me-widget img {\n  display:flex;\n  width: 100%;\n  max-width: 550px;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 12px;\n  margin: 0 auto 1.5rem;\n  border: 30px solid var(--royal-blue-dark);\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);\n  \n  border-bottom-width: 30px;\n  border-top-width: 30px;\n  border-style: ridge;\n}\n.about-me-widget h2 {\n  margin-top: 0;\n  color: var(--royal-blue-dark);\n  font-family: 'Merriweather_Italic', serif;\n  font-weight: bold;\n  font-size: 1.95rem;\n}\n.about-me-widget p {\n  margin-bottom: 0;\n  line-height: 1.55;\n  font-family: 'Lora_SemiBoldItalic', serif;\n  font-size: 1.5rem;\n  padding-left: 2.65rem;\n  padding-right: 2.65rem;\n  \n}\n.second-description-widget {\n  margin-top: 1rem;\n  font-size: 1.2rem;\n  text-align: center;\n  padding-top: 5rem;\n  padding-bottom: 2rem;\n}\n.second-description-widget p {\n  margin-bottom: 0;\n  line-height: 1.55;\n  font-family: 'Lora_Italic', serif;\n  font-size: 1.5rem;\n  padding-left: 2.65rem;\n  padding-right: 2.65rem;\n  padding-bottom: 50px;\n  border: 2px solid var(--royal-blue-dark);\n  border-radius: 12px;\n  border-bottom-width: 40px;\n  background-color: var(--royal-blue);\n  color: #fff;\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);\n  padding-top: 30px;\n}\n@media (min-width: 900px) {\n  body {\n    background-size: 40vh auto;\n  }\n\n  .content-welcome-container {\n    flex-direction: row;\n    align-items: flex-start;\n    gap: 1.25rem;\n  }\n\n  .site-sidebar {\n    width: 280px;\n    flex-shrink: 0;\n    order: 1;\n  }\n\n  .content-card-testimonials {\n    order: 2;\n  }\n}\n\n\n@media (min-width: 768px) {\n  .page {\n    padding: 1rem 1.25rem 1.25rem;\n    gap: 1rem;\n  }\n\n  body {\n    background-image: url('../public/images/backforsmalscreen.jpg');\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n    background-attachment: fixed;\n  }\n\n  .site-header {\n    padding: 1.4rem;\n  }\n\n  .site-title {\n    font-size: 2rem;\n    padding-left: 1rem;\n  }\n\n  .site-subtitle {\n    font-size: 1.05rem;\n    padding-left: 1rem;\n  }\n\n  .content-wrapper {\n    padding: 2rem;\n  }\n\n  .content-card {\n    padding: 1.5rem 2rem;\n  }\n\n  .content-card-testimonials {\n    padding: 1.5rem 2rem;\n  }\n\n  .site-sidebar {\n    padding: 1.25rem 1.35rem;\n    font-family: 'Merriweather_Italic', serif;\n  }\n}\n@media screen and (min-width: 320px) and (max-width: 800px) {\n  body {\n    background-image: url('../public/images/backforsmalscreen.jpg');\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n    background-attachment: fixed;\n  }\n  .photo-gallery-stage {\n    aspect-ratio: 4 / 3;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
